interface SortableItem {
  sort_value: number;
}

interface Destination {
  index: number;
}

export const calculateNewSortValue = (
  droppableArr: SortableItem[],
  destination: Destination
): number | undefined => {
  if (!Array.isArray(droppableArr)) {
    throw new Error('Invalid data type "droppableArr" must be an array');
  }

  if (droppableArr.length === 0) return undefined;

  if (destination.index === droppableArr.length - 1) {
    return droppableArr[destination.index - 1].sort_value + 1;
  }

  if (destination.index === 0) {
    return droppableArr[destination.index + 1].sort_value - 1;
  }

  const first = droppableArr[destination.index - 1].sort_value;
  const second = droppableArr[destination.index + 1].sort_value;
  return (first + second) / 2;
};
